export default () => ({
  // note: no styling yet, but keep the placeholder for later
  // when groups duplication feature will be implemented
});
